import { ExclamationCircleFilled } from '@ant-design/icons';
import {
  Dispatch,
  FC,
  ReactElement,
  SetStateAction,
  useEffect,
  useState,
} from 'react';

import { useUserInfo } from '@/hooks/useUserInfo';
import { useI18nContext } from '@/i18n/I18n';
import { getMerchantSecretInfo } from '@/services/oauthAdmin';

import { tabType } from '../type';
import { ResetSecretModal } from './ResetSecretModal';
import { SecretModal } from './SecretModal';
interface ISecretProps {
  setActiveTab: Dispatch<SetStateAction<tabType>>;
}

const SecretInfo: FC<{ title: string; content: string | ReactElement }> = ({
  title,
  content,
}) => {
  return (
    <div>
      <div className="secret-plain-text">{title}</div>
      {typeof content === 'string' ? (
        <div className="secret-plain-title">{content}</div>
      ) : (
        <div>{content}</div>
      )}
    </div>
  );
};

const ReviewOrResetBtn: FC<{ secretInfo: any }> = ({ secretInfo }) => {
  const [$t] = useI18nContext();
  const [showSecretModal, setShowSecretModal] = useState(false);
  const [showResetModal, setShowResetModal] = useState(false);
  const [info, setInfo] = useState(secretInfo);

  return (
    <>
      <span
        className="review-btn"
        onClick={() => {
          // 点击重置按钮，唤起重置密钥弹窗
          setShowResetModal(true);
        }}
      >
        {$t('reset2fa')}
      </span>
      {/* <span className="secret-review-warning">
        {isReview ? '仅允许查看一次，丢失请重置' : ''}
      </span> */}
      <ResetSecretModal
        showResetModal={showResetModal}
        closeModal={() => {
          setShowResetModal(false);
        }}
        handleSecretModal={({
          success,
          secret,
        }: {
          success: boolean;
          secret: string;
        }) => {
          if (success) {
            // 重置密钥成功唤起展示密钥弹窗
            setInfo((prevState: any) => {
              console.log('prevState--', prevState, secret);
              setShowSecretModal(true);
              return {
                ...prevState,
                secret,
              };
            });
          }
        }}
      />
      {showSecretModal && (
        <SecretModal
          showDetailModal={showSecretModal}
          apiKeyInfo={info}
          closeModal={() => {
            setShowSecretModal(false);
          }}
        />
      )}
    </>
  );
};

const Secret: FC<ISecretProps> = ({ setActiveTab }) => {
  const [$t] = useI18nContext();
  const { user, msgError } = useUserInfo();
  const [loading, setLoading] = useState(true);
  const [hasSecret, setHasSecret] = useState(false);
  const [clientId, setClientId] = useState('--');
  const [clientName, setClientName] = useState('--');

  useEffect(() => {
    console.log('挂载Secret组件 ONCE');
    getMerchantSecretInfo()
      .then((res) => {
        if (res?.result?.status !== -1) {
          setHasSecret(true);
          setClientId(res.result?.client_id);
          setClientName(res.result?.client_name);
        }
      })
      .catch((error) => {
        msgError(error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return !loading ? (
    <div className="oauth-admin-container-box-secret">
      <div className="oauth-admin-container-box-secret-content">
        <div className="secret-bold-title">
          {$t('oauthAdmin.secretInfoTitle')}
        </div>
        {!hasSecret && (
          <>
            <div className="secret-tips">
              <span className="icon">
                <ExclamationCircleFilled />
              </span>
              <span className="msg">{$t('oauthAdmin.secretInfoTips')}</span>
            </div>
          </>
        )}
        <div className="secret-info">
          <div>
            <SecretInfo title={$t('oauthAdmin.clientID')} content={clientId} />
            {/* <SecretInfo title={'授权Code'} content={clientName} /> */}
          </div>
          <div>
            <SecretInfo
              title={$t('oauthAdmin.clientSecret')}
              content={
                hasSecret ? (
                  <ReviewOrResetBtn
                    secretInfo={{
                      apiKey: clientId,
                      note: clientName,
                      secret: '',
                    }}
                  />
                ) : (
                  <span>--</span>
                )
              }
            />
          </div>
        </div>
      </div>
      {!hasSecret && (
        <div
          className="review-btn review-btn-lg"
          onClick={() => {
            setActiveTab(tabType.CONFIG_APP);
          }}
        >
          {$t('oauthAdmin.goNowBtn')}
        </div>
      )}
    </div>
  ) : (
    <></>
  );
};

export default Secret;
